import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "enum_display_target" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.combobox)
      ? (_openBlock(), _createBlock(_component_q_select, {
          key: 0,
          outlined: "",
          class: "thin-input",
          dense: "",
          modelValue: _ctx.group,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.group) = $event)),
          multiple: _ctx.allowMultiple,
          options: _ctx.options
        }, null, 8, ["modelValue", "multiple", "options"]))
      : (_openBlock(), _createBlock(_component_q_option_group, {
          key: 1,
          dense: "",
          modelValue: _ctx.group,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.group) = $event)),
          options: _ctx.options,
          size: "xs",
          color: "primary",
          type: _ctx.allowMultiple ? 'checkbox' : 'radio'
        }, null, 8, ["modelValue", "options", "type"]))
  ], 512))
}